/*
 * @Author: huangzq
 * @Date: 2019-09-29 17:07:42
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-17 14:59:34
 * @Desc: 新增、编辑弹窗
*/
<template>
  <mk-dialog
    :visible="visible"
    :title="type==='add'?'新建素材':'编辑素材'"
    width="1000px"
    top="0px"
    class="friend-dialog"
    @close="onClose"
    @closed="isBtnLoading=false"
  >
    <!-- @open="onOpen" -->
    <div
      v-loading="isDataLoading"
      class="dialog-content"
    >
      <mk-form
        ref="friendForm"
        :model="dialogData"
        :rules="rules"
        :validate-on-rule-change="false"
        label-width="92px"
      >
        <!-- 标题： -->
        <mk-form-item
          label="标题："
          prop="title"
        >
          <mk-input
            v-model="dialogData.title"
            width="320"
            placeholder="输入标题"
            maxlength="15"
          >
            <div slot="suffix">
              <span>{{ dialogData.title.length }}</span>
              <span>/15</span>
            </div>
          </mk-input>
        </mk-form-item>

        <!-- 标签： -->
        <mk-form-item label="标签：">
          <tag-select
            :key="dialogData.key"
            v-model="dialogData.tagIdList"
            width="320"
            tip="朋友圈素材的标签目前仅做分类筛选"
          />
        </mk-form-item>

        <!-- 类型： -->
        <mk-form-item label="类型：">
          <mk-radio-group
            v-if="!isDataLoading"
            v-model="friendType"
            size="small"
          >
            <mk-radio-button label="image">
              图片+文字
            </mk-radio-button>
            <mk-radio-button label="video">
              视频+文字
            </mk-radio-button>
            <mk-radio-button label="text">
              纯文本
            </mk-radio-button>
          </mk-radio-group>
        </mk-form-item>

        <!-- 文本内容： -->
        <mk-form-item
          label="文本内容："
          prop="context"
        >
          <div class="context">
            <mk-input
              v-model="dialogData.context"
              type="textarea"
              width="320"
              height="150"
              placeholder="请输入内容"
              maxlength="140"
              resize="none"
            />
            <div class="suffix">
              <span>{{ dialogData.context.length }}</span>
              <span>/140</span>
            </div>
          </div>
        </mk-form-item>

        <!-- 图片： -->
        <mk-form-item
          v-if="friendType==='image'"
          ref="images"
          label="图片："
          prop="images"
        >
          <mk-upload-oss-biz
            :bucket="this.$env.VUE_APP_ALI_OSS_BUCKET"
            :image-upload-limit="imageUploadLimit"
            upload-type="image"
            @on-upload="onImageUpload"
          >
            <div class="upload-image-wrapper">
              <template v-if="dialogData.images.length">
                <div
                  v-for="(img,index) in dialogData.images"
                  :key="index"
                  class="image-wrapper"
                >
                  <mk-image
                    :src="img"
                    fit="cover"
                    class="img"
                    alt="img"
                    @click="imageIndex=index"
                  />
                  <mk-iconfont
                    icon-class="guanbihuojingshihuocuowu"
                    class="icon"
                    @click.native.stop="removeImage(index)"
                  />
                </div>
              </template>
              <div
                v-if="dialogData.images.length<9"
                v-loading="imagesLoading"
                class="image-add"
                @click="imageIndex=-1"
              >
                <mk-iconfont
                  icon-class="xinzeng"
                  class="plus-icon"
                />
              </div>
            </div>
          </mk-upload-oss-biz>
          <div class="tips">
            只能上传{{ imageUploadLimit.accept }}文件，每张不超过{{ imageUploadLimit.limitSize }}M，最多支持9张图片
          </div>
        </mk-form-item>

        <!-- 视频 -->
        <mk-form-item
          v-else-if="friendType==='video'"
          label="视频："
          prop="video"
        >
          <mk-upload-oss-biz
            :bucket="this.$env.VUE_APP_ALI_OSS_BUCKET"
            :video-upload-limit="videoUploadLimit"
            :file-list="videoFileList"
            upload-type="video"
            show-file-list
            class="video-upload-oss"
            :on-remove="videoRemove"
            @on-upload="onVideoUpload"
          >
            <div class="video-cover">
              <mk-button-biz
                width="106px"
                icon="el-icon-upload2"
              >
                上传视频
              </mk-button-biz>
            </div>
          </mk-upload-oss-biz>
          <div class="tips">
            只能上传{{ videoUploadLimit.accept }}文件，且不超过{{ videoUploadLimit.limitSize }}M，建议时长不超过15秒
          </div>
        </mk-form-item>
      </mk-form>
    </div>

    <div class="footer-btn">
      <mk-button-biz
        width="64px"
        font-size="13px"
        @click="onClose"
      >
        取 消
      </mk-button-biz>
      <mk-button-biz
        v-if="isBtnLoading||isDataLoading"
        loading
        type="primary"
        width="64px"
        font-size="13px"
      />
      <mk-button-biz
        v-else
        type="primary"
        width="64px"
        font-size="13px"
        @click="checkFormData"
      >
        保 存
      </mk-button-biz>
    </div>
  </mk-dialog>
</template>

<script>
import { BIZAPIS } from '@api'
import tagSelect from '@components/tag-select'

export default {
  name: 'FirendDialog',
  components: { tagSelect },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object,
      default () {
        return {
          title: '',
          tagIdList: [],
          context: '',
          images: [],
          video: ''
        }
      }
    },
    // * 当前对的操作：add(新增)、edit(编辑)
    type: {
      type: String,
      default: 'add'
    },
    isDataLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 当前朋友圈的类型：图片+文字(image)、视频+文字(video)、纯文本(text)
      friendType: 'image',

      // * 是否需要替换图片，默认：-1（不替换）
      imageIndex: -1,

      // * 上传图片时的loading
      imagesLoading: false,

      // * 上传图片的相关限制
      imageUploadLimit: { accept: '.jpg,.png', limitSize: 5 },

      // * 上传视频的相关限制
      videoUploadLimit: { accept: '.mp4', limitSize: 50 },

      // * 上传视频的文件名称
      videoName: '',

      cloneDialogData: {},

      isBtnLoading: false
    }
  },

  computed: {
    rules () {
      // * 表单验证规则
      const rules = {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }]
      }
      if (this.friendType === 'text') {
        rules.context = [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      } else if (this.friendType === 'image') {
        rules.images = [
          {
            type: 'array',
            required: true,
            message: '请上传图片'
          }
        ]
      } else {
        rules.video = [{ required: true, message: '请上传视频' }]
      }
      return rules
    },
    videoFileList () {
      if (this.dialogData.videoName && this.dialogData.video) {
        return [{ name: this.dialogData.videoName, url: this.dialogData.video }]
      } else return []
    }
  },
  watch: {
    isDataLoading () {
      this.onOpen()
    }
  },

  methods: {
    /**
     * * 弹窗打开事件
     * * 处理friendType的初始值
     */
    onOpen () {
      if (this.type === 'add') this.friendType = 'image'
      else {
        const { images, video } = this.dialogData
        if (video) this.friendType = 'video'
        else if (images.length) this.friendType = 'image'
        else this.friendType = 'text'
      }
    },

    /**
     * * 弹窗关闭事件
     */
    onClose () {
      this.$refs.friendForm.clearValidate()
      this.imagesLoading = false

      this.$emit('update:visible', false)
      this.$emit('on-close')
    },

    /**
     * * 验证输入的数据是否符合规则
     */
    checkFormData () {
      this.$refs.friendForm.validate(valid => {
        if (valid) this.saveFun()
      })
    },

    /**
     * * 保存：根据type，调用不同的接口，实现新增或编辑素材
     */
    async saveFun () {
      this.isBtnLoading = true
      const {
        title,
        tagIdList,
        context,
        images,
        video,
        videoName
      } = this.dialogData
      const params = {
        title,
        tags: tagIdList,
        context,
        images
      }

      if (this.friendType === 'video') {
        params.images = []
        params.video = video
        params.videoName = videoName
      } else if (this.friendType === 'image') {
        params.video = ''
        params.videoName = ''
      } else if (this.friendType === 'text') {
        params.images = []
        params.video = ''
        params.videoName = ''
      }

      let res = {}
      let msg = '素材已更新！'
      if (this.type === 'add') {
        // 新增接口
        res = await BIZAPIS.MaterialCircleFriendsApi.materialCircleFriendsPost(
          params
        )
        msg = '新建素材成功！'
      } else {
        params._id = this.dialogData._id
        // 编辑接口
        res = await BIZAPIS.MaterialCircleFriendsApi.materialCircleFriendsPut(
          params
        )
      }

      if (res.success) {
        this.$message({
          type: 'success',
          message: msg
        })
        this.onClose()

        if (this.type === 'add') {
          this.$emit('on-update-list')
        } else {
          this.$emit('update-item')
        }
      } else this.isBtnLoading = false
    },

    /**
     * * 图片上传事件
     */
    onImageUpload (res) {
      if (res.type === 'fail') {
        this.imagesLoading = false
      } else if (res.type === 'success') {
        this.imagesLoading = false
        this.imagesUploadSuccess(res)
      } else if (['before', 'progress'].includes(res.type)) {
        this.imagesLoading = true
      }
    },

    /**
     * * 图片上传成功
     */
    imagesUploadSuccess (res) {
      this.$refs.images.clearValidate()
      if (this.imageIndex > -1) {
        this.$set(this.dialogData.images, this.imageIndex, res.result.url)
      } else {
        this.dialogData.images.push(res.result.url)
      }
    },

    /**
     * * 图片删除
     * @param index：图片数组下标
     */
    removeImage (index) {
      this.dialogData.images.splice(index, 1)
    },

    /**
     * * 视频删除事件
     */
    videoRemove () {
      this.dialogData.video = ''
      this.dialogData.videoName = ''
    },

    /**
     * * 视频上传事件
     */
    onVideoUpload (res) {
      this.cloneDialogData = this._.cloneDeep(this.dialogData)

      if (res.type === 'success') {
        this.videoUploadSuccess(res)
      } else if (res.type.match('fail')) {
        this.dialogData.video = this.cloneDialogData.video
        this.dialogData.videoName = this.cloneDialogData.videoName
      } else if (['before', 'progress'].includes(res.type)) {
        this.dialogData.video = ''
        this.dialogData.videoName = ''
      }
    },

    /**
     * * 视频上传成功
     */
    videoUploadSuccess (res) {
      this.dialogData.video = res.result.url
      this.dialogData.videoName = res.file.name
    }
  }
}
</script>

<style lang='scss' scoped>
.friend-dialog {
  & /deep/ .el-dialog {
    position: absolute;
    right: 0;
    top: 0;
    height: 100vh;
    margin: 0;
    border-radius: 0;

    .el-dialog__body {
      box-sizing: border-box;
      height: calc(100% - 107px);
      overflow: auto;

      .dialog-content {
        margin-left: 33px;

        & /deep/ .el-loading-mask {
          z-index: 20000;
        }

        .tips {
          margin-top: 5px;
          color: #8c8c8c;
          font-size: 12px;
          line-height: normal;
        }

        .context {
          position: relative;
          width: 320px;

          .suffix {
            position: absolute;
            right: 5px;
            bottom: 5px;
            line-height: normal;
            color: #c0c4cc;
          }
        }

        .upload-image-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;

          .image-wrapper {
            position: relative;
            margin-right: 10px;

            .img {
              width: 60px;
              height: 60px;
            }

            .icon {
              display: none;
              position: absolute;
              top: 0;
              right: 0;
              color: #f5222d;
            }

            &:hover {
              .icon {
                display: block;
              }
            }
          }

          .image-add {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            height: 60px;
            background-color: #fafafa;
            border-radius: 4px;
            border: 1px dashed #d4d4d4;

            .plus-icon {
              font-size: 27px;
            }
          }
        }

        .video-upload-oss {
          width: 320px;
        }
      }

      .footer-btn {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 1000px;
        height: 52px;
        line-height: 52px;
        text-align: center;
        background-color: #fff;
        border-top: 1px solid #e8e8e8;
        box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
      }
    }
  }
}
</style>
